"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _PreviewMedia = _interopRequireDefault(require("./PreviewMedia"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class PreviewHeader extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "renderMedia", () => {
      const _this$props = this.props,
            mediaType = _this$props.mediaType,
            mimeType = _this$props.mimeType,
            imageWidth = _this$props.imageWidth,
            imageHeight = _this$props.imageHeight;

      if (!mediaType) {
        return false;
      }

      let metadata = [];
      metadata.push({
        "name": "mediaType",
        "label": "Media"
      });
      metadata.push({
        "name": "mimeType",
        "label": "MIME type"
      });

      if (mediaType === "image") {
        metadata.push({
          "label": "Dimensions",
          "value": imageWidth + "x" + imageHeight
        });
      }

      return _react.default.createElement("div", null, _react.default.createElement("ul", {
        className: "field__metadata"
      }, metadata.map(this.renderMeta)), _react.default.createElement(_PreviewMedia.default, {
        formData: {
          media: this.props
        }
      }));
    });

    _defineProperty(this, "renderMeta", (meta, index) => {
      const name = meta.name,
            label = meta.label;
      const value = meta.value || this.props[name];

      if (!value) {
        return false;
      }

      return _react.default.createElement("li", {
        className: "field__meta",
        key: index
      }, _react.default.createElement("b", {
        className: "meta__label"
      }, label), " ", _react.default.createElement("i", {
        className: "meta__value"
      }, value));
    });

    _defineProperty(this, "renderMetadata", () => {
      const _this$props2 = this.props,
            uniqueId = _this$props2.uniqueId,
            parentId = _this$props2.parentId,
            locale = _this$props2.locale,
            status = _this$props2.status,
            createdAt = _this$props2.createdAt,
            updatedAt = _this$props2.updatedAt;
      const metadata = [{
        "name": "uniqueId",
        "label": "uniqueId"
      }, {
        "name": "parentId",
        "label": "parentId"
      }, {
        "name": "currentLocale",
        "label": "Locale"
      }, {
        "name": "status",
        "label": "Status"
      }, {
        "name": "createdAt",
        "label": "Created at"
      }, {
        "name": "updatedAt",
        "label": "Updated at"
      }];
      return _react.default.createElement("ul", {
        className: "field__metadata"
      }, metadata.map(this.renderMeta));
    });
  }

  render() {
    const _this$props3 = this.props,
          documentType = _this$props3.documentType,
          mediaType = _this$props3.mediaType,
          imageUrl = _this$props3.imageUrl,
          name = _this$props3.name,
          title = _this$props3.title,
          description = _this$props3.description,
          language = _this$props3.language,
          locale = _this$props3.locale,
          status = _this$props3.status,
          createdAt = _this$props3.createdAt,
          updatedAt = _this$props3.updatedAt;
    let fieldLabel, fieldType;

    if (documentType) {
      fieldLabel = documentType;
      fieldType = "document";
    }

    if (mediaType) {
      fieldLabel = mediaType;
      fieldType = "media";
    }

    if (!fieldType) {
      fieldLabel = name || "untitled";
      fieldType = "schema";
    }

    return _react.default.createElement("header", {
      className: "admin-preview__field  field--header"
    }, _react.default.createElement("h3", {
      className: "field__label"
    }, fieldLabel, " ", _react.default.createElement("em", {
      className: "field__type"
    }, fieldType)), _react.default.createElement("h1", {
      className: "field__title"
    }, title), this.renderMedia(), this.renderMetadata());
  }

}

var _default = PreviewHeader;
exports.default = _default;
module.exports = exports.default;